import { createRoute, useNavigate, useParams } from "@tanstack/solid-router";
import { adminRoute } from "./admin";
import { EmailTemplateManager } from "@/features/admin/components/email-template-manager";
import { PageContainer } from "@fleet/ui";

/**
 * `/admin/email/$templateId` — template edit editor addressable by URL
 * (campaign #15b). Previously a local signal (`editing`) without own URL. If id
 * does not exist, manager shows `NotFoundState` (not empty editor).
 * Dynamic segment: `new` and `campaigns` (static) win on match.
 */
function AdminEmailEditPage() {
  const navigate = useNavigate();
  const params = useParams({ from: adminEmailEditRoute.id });
  const back = () => {
    void navigate({ to: "/admin/email" });
  };
  return (
    <PageContainer maxWidth="6xl">
      <EmailTemplateManager
        mode={() => "edit"}
        editId={() => params().templateId}
        onClose={back}
        onNew={() => {
          void navigate({ to: "/admin/email/new" });
        }}
        onEdit={(id) => {
          void navigate({ to: "/admin/email/$templateId", params: { templateId: id } });
        }}
      />
    </PageContainer>
  );
}

export const adminEmailEditRoute = createRoute({
  getParentRoute: () => adminRoute,
  path: "/email/$templateId",
  component: AdminEmailEditPage,
});
